import { useSelector } from "react-redux";
import {
  selectAllPropPresets,
  selectSelectedTake3D,
} from "../app/slices/TrainingSlice";
import { selectUsedProps } from "../app/slices/PropLibrarySlice";
import { TakeAttachment } from "../models/TakeAttachment";

export default function useAttachmentHelper() {
  const propPresets = useSelector(selectAllPropPresets);
  const usedProps = useSelector(selectUsedProps);
  const currentTake = useSelector(selectSelectedTake3D)!;

  const getAllAttachableProps = () => {
    const attachables: string[] = [];

    // get all used props that have the category "Attachable" -> store the prop id's in an array
    for (const [key, value] of Object.entries(usedProps)) {
      if (value.propContent.categories.some((cat) => cat.name === "attachable"))
        attachables.push(key);
    }

    // go over all prop presets in the project and return the ones that are attachable
    return propPresets.filter((prop) => attachables.includes(prop.propId));
  };

  const getPropsAttachedToActor = (actorId: string) => {
    const actorAttachments: {
      attachment: TakeAttachment;
      propPreset: (typeof propPresets)[number];
      usedProp: (typeof usedProps)[string];
    }[] = [];

    for (const [key, value] of Object.entries(currentTake.attachments)) {
      if (value.id !== actorId) continue;

      const propPreset = propPresets.find((prop) => prop.id === key);
      if (!propPreset) throw new Error("No prop attached to actor");

      actorAttachments.push({
        attachment: value,
        propPreset,
        usedProp: usedProps[propPreset.propId],
      });
    }

    return actorAttachments;
  };

  return { getAllAttachableProps, getPropsAttachedToActor } as const;
}
